import { AnyAction } from 'redux';
import {
  GlobalActions,
  GlobalCommonInsuranceDataReceivedAction,
} from '@ps20-frontend/shop-integration-redux';
import { Tarifbereich } from '@ps20/bff-models';
import {
  BasisAdresse,
  determineAssekuranztarifFromTarifbereich,
} from '@ps20-frontend/frontend-models';

export interface Versicherungsnehmer {
  geburtsdatum: string;
  isAssekuranztarif: boolean;
  tarifbereich?: Tarifbereich;
  adresse: BasisAdresse;
}

export const versicherungsnehmerReducer = function (
  sectionState: Versicherungsnehmer = null,
  action: AnyAction,
): Versicherungsnehmer {
  switch (action.type) {
    case GlobalActions.COMMON_INSURANCE_DATA_RECEIVED:
      return setVn(sectionState, action as GlobalCommonInsuranceDataReceivedAction);
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA_AFTER_VV_LOAD:
      return { ...sectionState, isAssekuranztarif: action.payload };
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA:
      return { ...sectionState, isAssekuranztarif: action.payload };
    case GlobalActions.TARIFBEREICH_CHANGED:
      return {
        ...sectionState,
        isAssekuranztarif: determineAssekuranztarifFromTarifbereich(action.payload),
      };
    default:
      return sectionState;
  }
};

function setVn(
  sectionState: Versicherungsnehmer,
  action: GlobalCommonInsuranceDataReceivedAction,
): Versicherungsnehmer {
  const { adresse, geburtsdatum, isAssekuranztarif } = action.payload.versicherungsnehmer;
  return {
    ...sectionState,
    adresse: {
      plz: adresse.plz,
      strasse: adresse.strasse,
      ort: adresse.ort,
      hausnummer: adresse.hausnummer,
    },
    geburtsdatum,
    isAssekuranztarif,
  };
}
